<div class="flex-row header-wrapper"><h3>Contact Us</h3>
  <button mat-icon-button aria-label="close dialog" mat-dialog-close="true" class="button-close">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content class="contactUs-Content">
  <form [formGroup]="form" [class.error]="!form.valid && form.touched" class="flex-column dense-5">
    <div class="content-wrapper flex-column">
      <div class="flex-column">
        <div class="flex-row mb-2">
          <div class="label">
            <label for="title">Title*</label>
          </div>
          <mat-form-field class="w-100 styled" appearance="outline">
            <input type="text" matInput name="title" maxlength="100" formControlName="title" placeholder="Enter Title"
                   id="title">
            <mat-error *ngIf="form.controls.title.hasError('required')">
              Title is required
            </mat-error>
          </mat-form-field>
        </div>
        <div class="flex-row mt-1 mb-2">
          <div class="label">
            <label for="descr">Description*</label>
          </div>
          <mat-form-field class="w-100 styled textarea" appearance="outline">
          <textarea matInput name="description" maxlength="2500" formControlName="description"
                    placeholder="Enter Description" id="descr"></textarea>
            <mat-error *ngIf="form.controls.description.hasError('required')">
              Description is required
            </mat-error>
          </mat-form-field>
        </div>
        <div class="flex-row mt-1" *ngIf="!isAnonymous">
          <div class="label">
            <label for="user-name">User name*</label>
          </div>
          <mat-form-field class="w-100 styled" appearance="outline" readonly="true">
            <input type="email" class="text-black" matInput maxlength="255" formControlName="username" readonly
                   id="user-name">
          </mat-form-field>
        </div>
        <div class="flex-row mt-1">
          <div class="label">
            <label for="email">Email*</label>
          </div>
          <mat-form-field class="w-100 styled" appearance="outline" subscriptSizing="dynamic">
            <input type="email" class="text-black" matInput maxlength="255" formControlName="email"
                   [readonly]="!isAnonymous"
                   placeholder="Enter Email" id="email">
            <mat-error *ngIf="form.controls.email.hasError('required')">
              Email is required
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="footer-wrapper text-end">
      <button mat-stroked-button class="styled primary" (click)="sendFeedback()"
              [disabled]="loading || !form.valid">Send
      </button>
      <button mat-stroked-button class="styled secondary ms-2" (click)="close()">Close
      </button>
    </div>
  </form>
</mat-dialog-content>
